import type { Travel } from "../../getTravel";
import { Review } from "./Review";

type Props = {
  reviews: Travel["reviews"];
  showAll: boolean;
};
export const Columns = ({ reviews, showAll }: Props) => {
  if (reviews.length === 0) return null;

  return (
    <div className="grid grid-cols-1 gap-4">
      {reviews.slice(0, showAll ? reviews.length : 2).map((review) => (
        <Review key={review.id} review={review} />
      ))}
    </div>
  );
};
